"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var css = _interopRequireWildcard(require("./DropDown.style"));

var _ = require("../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * DropDowns display informative content or form inputs in a floating Card that
 * is displayed beneath a button, which a user may press to toggle visibility of
 * the content.
 *
 * When a DropDown is open, a user may also dismiss the DropDown by pressing the
 * ESC key.
 *
 * The UX will change based on the viewport size. On smaller screens, the layout
 * will adapt from a floating Card to an instance of the `Drawer` component. The
 * `Drawer` will mount in a new node in the body element, and be presented as a
 * full-screen dialog similar to the modal component.
 */
const DropDown = ({
  alignment = 'left',
  children,
  initialOpen,
  onClose,
  onOpen,
  renderTrigger,
  title,
  isOpen,
  zIndex = 1,
  minWidth = 240
}) => {
  const [open, setOpen] = React.useState(initialOpen);
  const rootRef = React.useRef(null);
  const {
    width
  } = (0, _.useViewportSize)();
  const showCard = !!width && width >= 600;
  const shouldHandleClose = showCard && open;
  React.useEffect(() => {
    if (isOpen !== undefined) setOpen(isOpen);
  }, [isOpen]);
  const handleClose = React.useCallback(() => {
    setOpen(false);
    onClose();
  }, [onClose]);
  const handleOpen = React.useCallback(() => {
    setOpen(true);
    onOpen();
  }, [onOpen]);
  (0, _.useOutsideClick)(rootRef, handleClose, shouldHandleClose);
  (0, _.usePressEscape)(shouldHandleClose ? handleClose : undefined);
  return (0, _pragma.createFelaElement)("div", {
    css: css.root,
    ref: rootRef
  }, renderTrigger({
    'aria-expanded': open,
    onClose: handleClose,
    onOpen: handleOpen,
    open
  }), showCard && (0, _pragma.createFelaElement)(_.Card, {
    as: _.View,
    "aria-hidden": !open,
    css: css.card,
    cssProps: {
      alignment,
      open,
      zIndex,
      minWidth
    },
    padding: ['xlarge', 'medium'],
    role: "tooltip",
    children: children
  }), open && !showCard && (0, _pragma.createFelaElement)(_.Drawer, {
    title: title,
    onClose: handleClose
  }, children));
};

DropDown.displayName = 'DropDown';
var _default = DropDown;
exports.default = _default;
//# sourceMappingURL=DropDown.js.map